import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTreeViewFullScreen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.96875 0.625H12.4688C12.8242 0.625 13.125 0.925781 13.125 1.28125V4.78125C13.125 5.16406 12.8242 5.4375 12.4688 5.4375C12.0859 5.4375 11.8125 5.16406 11.8125 4.78125V2.86719L7.90234 6.75L11.8125 10.6602V8.71875C11.8125 8.36328 12.0859 8.0625 12.4688 8.0625C12.8242 8.0625 13.125 8.36328 13.125 8.71875V12.2188C13.125 12.6016 12.8242 12.875 12.4688 12.875H8.96875C8.58594 12.875 8.3125 12.6016 8.3125 12.2188C8.3125 11.8633 8.58594 11.5625 8.96875 11.5625H10.8828L7 7.67969L3.08984 11.5625H5.03125C5.38672 11.5625 5.6875 11.8633 5.6875 12.2188C5.6875 12.6016 5.38672 12.875 5.03125 12.875H1.53125C1.14844 12.875 0.875 12.6016 0.875 12.2188V8.71875C0.875 8.36328 1.14844 8.0625 1.53125 8.0625C1.88672 8.0625 2.1875 8.36328 2.1875 8.71875V10.6602L6.07031 6.75L2.1875 2.86719V4.78125C2.1875 5.16406 1.88672 5.4375 1.53125 5.4375C1.14844 5.4375 0.875 5.16406 0.875 4.78125V1.28125C0.875 0.925781 1.14844 0.625 1.53125 0.625H5.03125C5.38672 0.625 5.6875 0.925781 5.6875 1.28125C5.6875 1.66406 5.38672 1.9375 5.03125 1.9375H3.08984L7 5.84766L10.8828 1.9375H8.96875C8.58594 1.9375 8.3125 1.66406 8.3125 1.28125C8.3125 0.925781 8.58594 0.625 8.96875 0.625Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgIconTreeViewFullScreen);
export { ForwardRef as ReactComponent };
